import type { FC } from 'react';

import { BattleshipGameLocal } from './BattleshipGame';
import { ChessGameLocal } from './ChessGame';
import { FourInARowGameLocal } from './FourInARowGame';
import { TicTacToeGameLocal } from './TicTacToeGame';
import type { TGamePlayer } from './types';

export interface IGameComponentProps {
  player1: TGamePlayer;
  player2: TGamePlayer;
  aiDifficulty?: number;
  rules: string;
  showTestPromotionButton?: boolean;
  showTestSituationButtons?: boolean;
  onGameEnd?: (result: unknown) => void;
  onSurrender?: () => void;
}

type TGameComponent = FC<IGameComponentProps>;

interface IGameRegistry {
  [slug: string]: TGameComponent;
}

export const localGameRegistry: IGameRegistry = {
  battleship: BattleshipGameLocal as TGameComponent,
  'classic-chess': ChessGameLocal as TGameComponent,
  'four-in-a-row': FourInARowGameLocal as TGameComponent,
  'tic-tac-toe': TicTacToeGameLocal as TGameComponent,
};

export function getLocalGameComponent(slug: string): TGameComponent | null {
  return localGameRegistry[slug] || null;
}

export function isLocalGameAvailable(slug: string): boolean {
  return slug in localGameRegistry;
}
